import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";

import {
  ModalDismissReasons,
  NgbActiveModal,
  NgbModal,
} from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs/Observable";
import { TranslationService } from "../../../_services/translation.service";
import { ITranslations } from "../../../_models/ITranslations";
import { DepositData } from "../receipt-page-models/PaperPaymentItem";
import { Epoc } from "../../../_models/Epoc";
import { DateAndTimeUtils } from "../../../_helpers/dateUtils";

@Component({
  selector: "receipt-delete-modal",
  templateUrl: "./receipt-delete-modal.component.html",
  styleUrls: ["./receipt-delete-modal.component.scss"],
})
export class ReceiptDeleteModalComponent implements OnInit {
  @ViewChild("content") public contentRef: TemplateRef<any>;
  @Output("result") public modalResult: EventEmitter<any> =
    new EventEmitter<boolean>();
  @Input("openModal") public openModal: Observable<DepositData | null>;

  public modalText: string = "האם לבטל את הקבלה?";

  public modalHeader: string = "לאשר את ביטול הקבלה";
  public data: DepositData | false = false;
  public translations$: Observable<ITranslations>;
  public receiptNumber: string = "";

  constructor(
    private translationService: TranslationService,
    private modalService: NgbModal,
    public activeModal: NgbActiveModal
  ) {
    this.translations$ = this.translationService.translations;
  }

  public open(content) {
    // @ts-ignore
    this.activeModal = this.modalService
      .open(content, {
        backdrop: true,
        backdropClass: "custom-event-backdropClass",
      })
      .result.then(
        (result) => {
          this.modalResult.emit(result === "delete" ? this.data : false);
        },
        (reason) => {
          this.modalResult.emit(false);
        }
      );
  }
  public stringFromEpoc(epoc: Epoc) {
    const date = DateAndTimeUtils.serverEpochToDate(epoc);
    return `${date.getDate()}.${date.getMonth() + 1}.${
      date.getFullYear() - 2000
    }`;
  }
  public ngOnInit(): void {
    this.openModal.subscribe((data) => {
      this.data = data;

      const specificItem =
        data &&
        data.paymentBatch.paymentsItems.find(
          (item) => item.id === data.specificPaymentItemId
        );

      this.receiptNumber =
        (specificItem && specificItem.receiptNumber) ||
        (data &&
          data.paymentBatch &&
          data.paymentBatch.paymentsItems[0] &&
          data.paymentBatch.paymentsItems[0].receiptNumber) ||
        "";

      if (data) {
        if (specificItem) {
          this.data.paymentBatch.childName = specificItem.childName;
        }
        this.open(this.contentRef);
      }
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/receipt/receipt-utils-delete-modal/receipt-delete-modal.component.ts